import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
 

 
@Component({
  selector: 'page-kredi-karti-hareketleri',
  templateUrl: 'kredi-karti-hareketleri.html',
})
export class KrediKartiHareketleriPage {
  aranan="";
  skip: number = 0;
  take: number = 50;
HareketListesi=[];
 
BankaView:any={};

  constructor(public navCtrl: NavController,
 public ortak: Ortak,
public bllOrtak:BllOrtak,
public viewCtrl:ViewController,
 public navParams: NavParams) {
  if(navParams.get("BankaVw")!=null)
  {
    this.BankaView=navParams.get("BankaVw");
    var data =new FormData();
    data.append("Banka_id",this.BankaView.ID);
    this.bllOrtak.islem(data,"BankaHareketleriGetirByID","",false).then(a=>{
      var sonuc =<any>a;
      this.HareketListesi = sonuc.SonucObject;
    })
  }
   
  }

  ionViewDidLoad() {
    this.KayitleriGetir("");
    
  }

  KayitleriGetir(e)
  {this.aranan = this.BankaView.ID;

    var formData = new FormData();
    formData.append("Banka_id", JSON.stringify(this.aranan));
    this.bllOrtak.islem(formData, "BankaHareketleriGetirByID", "", false).then(a => {

      var sonuc = <any>a;
      this.HareketListesi = sonuc.SonucObject;
    

  })}
  kapat()
  {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/BankaIslemleri/kredi-karti-hareketleri/kredi-karti-hareketleri.ts